/**
 * Rich Text Block Type Constants
 *
 * Defines the node type strings used in Contentful rich text.
 * Replaces @contentful/rich-text-types to eliminate dependency.
 */

export const BLOCKS = {
  DOCUMENT: "document",
  EMBEDDED_ASSET: "embedded-asset-block",
  EMBEDDED_ENTRY: "embedded-entry-block",
  HEADING_1: "heading-1",
  HEADING_2: "heading-2",
  HEADING_3: "heading-3",
  HEADING_4: "heading-4",
  HEADING_5: "heading-5",
  HEADING_6: "heading-6",
  HR: "hr",
  HYPERLINK: "hyperlink",
  LIST_ITEM: "list-item",
  OL_LIST: "ordered-list",
  PARAGRAPH: "paragraph",
  QUOTE: "blockquote",
  TABLE: "table",
  TABLE_CELL: "table-cell",
  TABLE_HEADER_CELL: "table-header-cell",
  TABLE_ROW: "table-row",
  UL_LIST: "unordered-list",
} as const

export const MARKS = {
  BOLD: "bold",
  CODE: "code",
  ITALIC: "italic",
  UNDERLINE: "underline",
} as const
